import { CreateRuleEditorData, CreateRulesExecutionData } from "../src/easy_automations/rule_editor/types";
import { CreateQueryRuleExecutionData } from "../src/easy_automations/rules_query_execution/types";

window.EasyAutomations ||= {};

window.EasyAutomations.createRuleEditorApp = async (automationData: CreateRuleEditorData) => {
  const { createRuleEditorApp } = await import("../src/easy_automations/rule_editor/main");
  createRuleEditorApp(automationData);
};

window.EasyAutomations.createRulesExecutionApp = async (executionData: CreateRulesExecutionData) => {
  const { createRulesExecutionApp } = await import("../src/easy_automations/rules_execution/main");
  await createRulesExecutionApp(executionData);
};

window.EasyAutomations.createTaskListRulesExecutionApp = async (executionData: CreateRulesExecutionData) => {
  const { createTaskListRulesExecutionApp } = await import("../src/easy_automations/rules_execution/main");
  await createTaskListRulesExecutionApp(executionData);
};

window.EasyAutomations.createQueryRulesExecutionApp = async (queryData: CreateQueryRuleExecutionData) => {
  const { createQueryRulesExecutionApp } = await import("../src/easy_automations/rules_query_execution/main");
  await createQueryRulesExecutionApp(queryData);
};
